import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=58dfa508&scoped=true&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"
import style0 from "./notifications.vue?vue&type=style&index=0&id=58dfa508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dfa508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58dfa508')) {
      api.createRecord('58dfa508', component.options)
    } else {
      api.reload('58dfa508', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=58dfa508&scoped=true&", function () {
      api.rerender('58dfa508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications.vue"
export default component.exports